<template>
    <div class="topImgDiv" :style="{height:imgHeight,background:background}">
        <div class="inputDiv" v-show="showInput">
            <Input v-model="value" placeholder="" style="width: 411px" class="myInput"/>
            <Button class="myBtn" type="primary" icon="ios-search" @click="toSearch">查询</Button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "topImg",
        props:{
            imgHeight: {
                type:String,
                default: "584px"
            },
            background: {
                type:String,
                default: ""
            },
            showInput: {
                type: Boolean,
                default: true
            }
        },
        data(){
            return{
                value:""
            }
        },
        methods: {
          toSearch() {
            this.$router.push({
              path:'/toFindOut/progress',
              query:{
                cxtj: this.value
              }
            });
          }
        }
    }
</script>

<style lang="less" scoped>
    @import url("../../../../static/css/common.less");
    .topImgDiv{
        width:100%;
        height:584px;
        background:url("../../../../static/img/topImgBg.png") 0 0 no-repeat;
        background-size:cover;
    }
    .inputDiv{
        width: @indexCommonWidth;
        margin: 0 auto;
        position: relative;
        top:273px;
    }
    .myInput /deep/ .ivu-input{
        height:40px;
        background:rgba(255,255,255,0.85);
    }
    .myBtn{
        width:92px;
        height:40px;
        border-radius: 4px;
        background: #E6A23C;
        border:0;
        outline:none;
        margin-left:4px;
    }
</style>
